import React from "react";
import { Box } from "@mui/material";
import { IMG_PLACEHOLDER, STORAGE_BUCKET } from "../../constants";
import { getOptimizedCloudinaryUrl } from "../../util";
import EmblaCarousel from "../carousel/EmblaCarousel";

export default function ImageCarousel(props) {
  let style = props.style || {
    width: "100%",
    aspectRatio: "1",
    objectFit: "cover",
    borderRadius: "4px",
  };

  let images = props.images.filter((item) => item) || [];
  if (!images || images.length === 0) {
    images.push(`${STORAGE_BUCKET}${IMG_PLACEHOLDER}`);
  }

  const hasMultipleImages = images.length > 1;

  return (
    <Box id="images" style={{ cursor: "pointer", borderRadius: "3px" }} align="center">
      <EmblaCarousel
        interval={5000}
        transitionTime={1000}
        sx={{ aspectRatio: style.aspectRatio || "1" }}
      >
        {images.map((pic, idx) => {
          return (
            <Box key={idx} sx={{ width: "100%", height: "100%" }}>
              <img alt="" src={getOptimizedCloudinaryUrl(pic)} style={style} />
            </Box>
          );
        })}
      </EmblaCarousel>
    </Box>
  );
}
